import { useStoreData } from '@/Store/storeData';

export function computeCost(items) {
    let cost = 0;
    let itemPrice, itemCount;
    for (let item of items) {
        itemPrice = +(item.price??0);
        itemCount = +(item.count??0);
        cost += itemPrice * itemCount;
    }
    return cost+computeAccessories();
}

export function computeAccessories(){
    let accessoriesPrice=0;
    let accessories=useStoreData().categoriesItems;
    Object.keys(accessories).forEach((id)=>{
        let accessory=((useStoreData().getItemsByIdArr(id).find(item=>item.id==id)));
        accessoriesPrice+=accessories[id]*accessory.price;
    });
    return accessoriesPrice;
}